import { FC, useContext, useEffect, useState } from "react";
import Select, { GroupBase, OptionsOrGroups, PropsValue, SingleValue } from "react-select";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { CASE_INDICATION } from "src/constants/addCase";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { RequestDateOfTreatmentProps, RequestTreatmentNotTreatingApiResponse } from "./types";



const ConfirmIndication: FC<RequestDateOfTreatmentProps> = ({ isModalVisible, caseId, hideModal, prescriptionId ,refreshListing}): JSX.Element => {
  const [cancelReason, setCancelReason] = useState<string>('Cost');

  const { data: requestTreatmentData, mutate: updateRequestTreatment, error: treatmentUpdateError } = useFetch<RequestTreatmentNotTreatingApiResponse>(APIEndpoints.REQUEST_TREATMENT_NOT_TREATING, {}, { caseId, prescriptionId })
  const { showToast } = useContext(ToastContext);

  const submitForm = () => {
    if (cancelReason) {
      const requestBody = {
        "prescription ": {
          "bentype": "",
          "confirmed_indication": cancelReason
        }
      }
      updateRequestTreatment(requestBody)
    } else if (cancelReason === '') {
      showToast([`Please Enter Reason First.`], ToastTypes.WARNING);
    }
  }

  const getValue = () => {
    const data = CASE_INDICATION.find((option) => option.value === cancelReason);
    if (data) return data as unknown as PropsValue<string>;
  };

  const onChangeSelect = (value: SingleValue<string>) => {
    setCancelReason((value as unknown as { value: string; label: string; }).value);
  };

  useEffect(() => {
    if (requestTreatmentData || treatmentUpdateError) {
      hideModal()
      if(requestTreatmentData){
        const { code } = requestTreatmentData;
        if (code === 200) {
          showToast([`Confirm Indication Scheduled Successfully`], ToastTypes.SUCCESS);
          refreshListing()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestTreatmentData, treatmentUpdateError]);

  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title m-0" style={{color:'#008853', fontSize:'1.875rem'}}>
              Confirm Indication For Case {caseId}
            </h1>
            <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
          </div>

          <div className="modal-body">
            {/* <p className="text-center my-3"> Please specify date of treatment... </p> */}

            <div className="row mx-3 align-items-center">
              <div className="col-4 text-end">
                <label htmlFor="treatmentDate"> Confirm Indication </label>
              </div>
              <div className="col-8">
                <Select
                    options={(CASE_INDICATION.map((indi) => ({ value: indi.value, label: indi.label }))) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                    id="cancelTreatment"
                    isSearchable={false}
                    noOptionsMessage={() => "Select Option..."}
                    value={getValue()}
                    onChange={(value) => onChangeSelect(value)}
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-blue px-4" data-bs-dismiss="modal" onClick={submitForm}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmIndication;
